import type { QuoteSnapshot } from '../types.ts'

const BASE = '/api/quotes'

export interface QuotesResponse {
  results: QuoteSnapshot[]
  missingSymbols: string[]
}

export async function getQuotesByTickers(symbols: string[]): Promise<QuotesResponse> {
  const normalized = [...new Set(symbols.map((symbol) => symbol.trim().toUpperCase()).filter(Boolean))]

  if (normalized.length === 0) {
    return { results: [], missingSymbols: [] }
  }

  const query = encodeURIComponent(normalized.join(','))
  const res = await fetch(`${BASE}?tickers=${query}`)

  if (!res.ok) {
    const payload = (await res.json().catch(() => ({}))) as { error?: string }
    throw new Error(payload.error ?? 'Erro ao buscar cotações')
  }

  return res.json() as Promise<QuotesResponse>
}

